/**
 * @generated SignedSource<<5efa24dcaa194c9b395c5c061e2f26ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type requestsFragment$data = {
  readonly id: string;
  readonly contact: {
    readonly " $fragmentSpreads": FragmentRefs<"contactFragment">;
  };
  readonly account: {
    readonly " $fragmentSpreads": FragmentRefs<"accountBaseFragment">;
  };
  readonly preferredPractitioner: {
    readonly " $fragmentSpreads": FragmentRefs<"userProfileBaseFragment" | "userProfileNameFragment">;
  } | null;
  readonly event: {
    readonly " $fragmentSpreads": FragmentRefs<"eventFragment">;
  } | null;
  readonly comment: string | null;
  readonly createdAt: any | null;
  readonly " $fragmentType": "requestsFragment";
};
export type requestsFragment$key = {
  readonly " $data"?: requestsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"requestsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "requestsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Contact",
      "kind": "LinkedField",
      "name": "contact",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "contactFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "accountBaseFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfile",
      "kind": "LinkedField",
      "name": "preferredPractitioner",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "userProfileBaseFragment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "userProfileNameFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "event",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "eventFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "comment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    }
  ],
  "type": "EventRequest",
  "abstractKey": null
};

(node as any).hash = "a7c03a2863c6206fe9f471e679d341dc";

export default node;
